<a mat-list-item *ngIf="!dashboard.externalUrl" [routerLink]="['/', dashboard.routerLink]">
  <mat-icon matListIcon>{{dashboard.matIcon}}</mat-icon><span matLine>{{dashboard.title}}</span>
</a>
<a mat-list-item *ngIf="dashboard.externalUrl" [href]="dashboard.externalUrl" target="_blank">
  <mat-icon matListIcon>{{dashboard.matIcon}}</mat-icon><span matLine>{{dashboard.title}}</span>
  <mat-icon class="launch-icon">launch</mat-icon>
</a>
